<template>
    <section class="bedrijf tekst light purple">
        <circles-layout></circles-layout>

        <h1>Wij zijn Onderwijsgroep Tilburg</h1>

        <p>Onderwijsgroep Tilburg is een middelgrote onderwijsorganisatie voor voorbereidend en middelbaar beroepsonderwijs in Brabant. Wij ontwikkelen voortdurend ons onderwijs om leerlingen en studenten de beste voorbereiding te geven op een zelfstandige toekomst.</p>

        <p>Wij verzorgen onderwijs vanuit drie vmbo-scholen (Campus 013, Reeshof College, Schakelcollege Tilburg), vijftien mbo-scholen (ROC Tilburg) en drie scholen voor funderend onderwijs (Vavo, Educatie en Inburgering en Entree-opleidingen). Tevens zijn wij met NCVB Bedrijfsopleidingen landelijk toonaangevend op het gebied van maatwerk bedrijfsopleidingen op mbo-niveau. Met zo’n 1.200 medewerkers zorgen wij ervoor dat ruim 14.000 leerlingen, studenten en cursisten goed onderwijs kunnen volgen.</p>

        <p>Onderwijsgroep Tilburg is ambitieus. In de regio zorgen we voor een doorlopend en aansluitend aanbod van voorbereidend middelbaar en middelbaar beroepsonderwijs in alle sectoren en leerwegen. Ook bieden wij mbo-maatwerkoplossingen voor het bedrijfsleven. Onze scholen krijgen daarbij professionele en efficiënte ondersteuning van onze ondersteunende diensten. Wij bundelen en benutten beschikbare kennis en ervaring. Die zetten wij in voor zowel onze eigen scholen als voor onze partners in de regio.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    // import InterviewOrganisatie from '@/app/pages/sub/InterviewOrganisatie';
    import Maps from '@/app/pages/bedrijf/Maps.vue';

    export default {
        name: 'Bedrijf',
        meta: {
            title: '2. Wij zijn Onderwijsgroep Tilburg',
            color: '#a5147e',
            slides: [ Maps ]
        },
        components: {
            'circles-layout': Circles
        },

        mounted()
        {
        },
        methods: {
            openInterview()
            {
                // this.$emit( 'openOverlay', InterviewOrganisatie );
            },

            sub( name )
            {
                /*
                switch( name )
                {
                    case 'Organisatie':
                        this.$emit( 'openOverlay', InterviewOrganisatie );
                        break;
                } */
            }
        }
    };
</script>
